import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogActions,
    Button,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { useActiveConversationsToolbarStyles } from './ActiveConversationsToolbar.styles';

interface IMarkResolvedConfirmationDialogProps {
    open: boolean;
    hasCategory: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const MarkResolvedConfirmationDialog: React.FC<IMarkResolvedConfirmationDialogProps> = ({
    open,
    hasCategory,
    onConfirm,
    onCancel,
}) => {
    const { t } = useTranslation();
    const styles = useActiveConversationsToolbarStyles();

    const handleCancel = useCallback(() => {
        onCancel();
    }, [onCancel]);

    const handleConfirm = useCallback(async () => {
        await onConfirm();
    }, [onConfirm]);

    const dialogContent = hasCategory ? (
        <DialogContent>
            {t('Dialog_MarkResolved')}
        </DialogContent>
    ) : (
        <DialogContent className={styles.dangerDialogContent}>
            {t('Dialog_MarkResolved_CategoryRequired')}
        </DialogContent>
    );

    return (
        <Dialog open={open} onOpenChange={(_, data) => data.open || handleCancel()}>
            <DialogSurface className={styles.dialogSurface}>
                <DialogBody>
                    <DialogTitle
                        action={
                            <Button
                                appearance="subtle"
                                aria-label={t('Dialog_Common_Cancel')}
                                onClick={handleCancel}
                                icon={<Dismiss24Regular />}
                            />
                        }
                    >
                        {t('Dialog_MarkResolved_Title')}
                    </DialogTitle>
                    {dialogContent}
                    {hasCategory && (
                        <DialogActions>
                            <Button appearance="secondary" onClick={handleCancel}>
                                {t('Dialog_Common_Cancel')}
                            </Button>
                            <Button appearance="primary" onClick={handleConfirm}>
                                {t('Button_MarkResolved')}
                            </Button>
                        </DialogActions>
                    )}
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
